import {GameRoundPresentation} from "@nolimitcity/slot-game/bin/timelinegameround/core/gameround/GameRoundPresentation";
import {Timeline} from "gsap";
import {TombOfAkhenaten} from "../../TombOfAkhenaten";
import {TombOfAkhenatenParsedGameData} from "../../server/data/TombOfAkhenatenParsedGameData";
import {TombOfAkhenatenGameConfig} from "../../TombOfAkhenatenGameConfig";

export class TOANearWin implements GameRoundPresentation {
    private readonly _reelId: number;

    constructor(reelId: number) {
        this._reelId = reelId;
    }

    public getAnimation(data: TombOfAkhenatenParsedGameData): Timeline | null {
        let nearWinPositionsData = data.nearWinPositions.reduce((acc, currEl) => acc.concat(<any>currEl), []);

        if (nearWinPositionsData[this._reelId]) {
            return TombOfAkhenaten.timelineReelsController.startNearWin(this._reelId, TombOfAkhenatenGameConfig.instance.REEL_NEAR_WIN_STOP_DELAY);
        }

        return null;
    }
}